import React from 'react'
import map from 'lodash/map'
import ContentSelect from '../../../core/components/content-select/ContentSelect'
import VisibleGMExplanationsFilter from '../containers/VisibleGMExplanationsFilter'
import InteractiveContentBlocks from '../../../core/components/interactive-content-blocks/InteractiveContentBlocks'
import LoadingSpinner from '../../../core/components/loading-spinner/LoadingSpinner'
import {UniLink} from '../../../core/components/unilink/index'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './grandmasterExplanations.css'


const GrandmasterExplanations = ({explanations, activeExplanation, isLoading, chooseActiveExplanation, openShare, colorSubject, toggleVote, report}) => {
  const {authors, voteCount, id, renderedContent, type, currentUserHasVoted, slug} = activeExplanation
  const authorString = map(authors, (a,index)=>{
    if (index === 0) return a.displayName
    if (index === 1) return 'et al'
    else return null
  }).join(' ')
  /*const getNextExplanationId = () => {
    const explanationIds = explanations.map(e=>e.id)
    const currExplanationIndex = explanationIds.indexOf(id)
    const nextExplanationIndex = currExplanationIndex < explanationIds.length-1 ? currExplanationIndex+1 : 0
    return explanationIds[nextExplanationIndex]
  }
  const getPreviousExplanationId = () => {
    const explanationIds = explanations.map(e=>e.id)
    const currExplanationIndex = explanationIds.indexOf(id)
    const prevExplanationIndex = currExplanationIndex > 0 ? currExplanationIndex-1 : explanationIds.length-1
    return explanationIds[prevExplanationIndex]
  }*/
  // const nextExplanationId = getNextExplanationId()
  // const previousExplanationId = getPreviousExplanationId()
  return (
    <div className='grandmaster-explanations'>
      <div className='grandmaster-explanations__select-container'>

        <span className='grandmaster-explanations__section-title'>
          {explanations.length} Explanations
        </span>
        <div className='grandmaster-explanations__select'>
          <ContentSelect
            className='grandmaster-explanations__content-select'
            content={explanations}
            chooseActiveFromId={chooseActiveExplanation}
            activeId={id}
            colorSubject={colorSubject}
            toggleVote={toggleVote}
            dark
          />
          <VisibleGMExplanationsFilter
            className="grandmaster-explanations__content-filter" />
        </div>
      </div>
      {
        // <div className='grandmaster-explanations__nav-explanations'>
        // <UniLink
        //   className='grandmaster-explanations__nav-explanation grandmaster-explanations__nav-explanation--prev'
        //   onClick={()=>{chooseActiveExplanation(previousExplanationId)}}>
        //   <UniLink ><FontAwesomeIcon icon={['fa', 'angle-left']} />
        //   Previous Explanation
        // </UniLink>
        // <UniLink
        //   className='grandmaster-explanations__nav-explanation grandmaster-explanations__nav-explanation--next'
        //   onClick={()=>{chooseActiveExplanation(nextExplanationId)}}>
        //   Next Explanation
        //   <UniLink ><FontAwesomeIcon icon={['fa', 'angle-right']} />
        // </UniLink>
        //</div>
      }
      {
        isLoading
          ? (
            <div className='grandmaster-explanations__content-blocks-container'>
              <div className='grandmaster-explanations__content-blocks-header'>
                <div className='grandmaster-explanations__content-blocks-authors' />
              </div>
              <LoadingSpinner delay={200} />
              <div className='gm-interactive-content__footer'>
                <UniLink ><FontAwesomeIcon icon={['fa', 'share-alt']} /> Share</UniLink>
                <UniLink ><FontAwesomeIcon icon={['fa', 'exclamation-circle']} /> Report</UniLink>
              </div>
            </div>
          )
          : (
            <div className='grandmaster-explanations__content-blocks-container'>
              <div className='grandmaster-explanations__content-blocks-header'>
                <UniLink
                  onClick={()=>{
                    toggleVote(type, id)
                  }}
                  className='grandmaster-explanations__content-blocks-votes'>
                  { currentUserHasVoted ? <FontAwesomeIcon icon={['fa', 'heart']} /> : <FontAwesomeIcon icon={['far', 'heart']} /> } {voteCount}
                </UniLink>
                <div className='grandmaster-explanations__content-blocks-authors'>
                  {`Explanation by ${authorString}`}
                </div>
              </div>
              <InteractiveContentBlocks
                content={renderedContent}
                type={type}
                as='grandmasterExplanation'
              />
              <div className='gm-interactive-content__footer'>
                <UniLink onClick={()=>openShare(slug, type)}><FontAwesomeIcon icon={['fa', 'share-alt']} /> Share</UniLink>
                <UniLink onClick={()=>report(activeExplanation)}><FontAwesomeIcon icon={['fa', 'exclamation-circle']} /> Report</UniLink>
              </div>
            </div>
          )
      }
    </div>
  )
}

export default GrandmasterExplanations



// WEBPACK FOOTER //
// ./src/domains/grandmaster/components/GrandmasterExplanations.js